import * as React from 'react';

import decreaseIcon from './decrease.svg';
import increaseIcon from './increase.svg';
import noChangeIcon from './noChange.svg';
import { EPriceDiff } from '../../../types/redux/estimationHistory';

const iconsMap: Record<EPriceDiff, string> = {
  [EPriceDiff.Decrease]: decreaseIcon,
  [EPriceDiff.Increase]: increaseIcon,
  [EPriceDiff.NotChanged]: noChangeIcon,
};

interface IDiffIconProps {
  diff: EPriceDiff;
  className?: string;
}

export const DiffIcon: React.VFC<IDiffIconProps> = ({ diff, className }) => {
  return <img className={className} src={iconsMap[diff]} alt="" />;
};
